module.exports = __webpack_public_path__ + "fonts/loading-fonts4.7817a82.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/loading/loading-fonts4.ttf
// module id = ./assets/loading/loading-fonts4.ttf
// module chunks = 2 3 4 5 6 7 8